module.exports = __webpack_public_path__ + "img/javascript-MacBook-Pro-mockup-front-page.317c4fed.jpg";